// extracted by mini-css-extract-plugin
module.exports = {"header":"GeneralTasksSidebar_header__1RMC7","taskField":"GeneralTasksSidebar_taskField__38-Zw","tabsMenu":"GeneralTasksSidebar_tabsMenu__2NtS8"};